import React, {useEffect, useContext} from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Success from '../../Assets/Icons/Icon_Color_Reserved.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';

export default function Subwindow_Modal_Register_RequestSent({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Reservation_Step_Set, Reservation_Clear } = useScheduleManagement();
    const Close = (Type) => {
        if (Type == "Restart") {
            Reservation_Step_Set("Tab_Info_Request");
        } else if (Type == "Entirely") {
            UI.Subwindows_Close("Window_ScheduleManagement_Reserve");
            setTimeout(function () {
                Reservation_Clear();
            }, 1000);
        }
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    return (
        <ui-subwindow Type='Modal' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    
                </h2>
                <button className='Subwindow_TitleBar_Control'>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Success} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>

                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Reservation request sent!
                </h2>
                
                <p className='General_Paragraph' style={{textAlign: "center", marginBottom: "10px"}}>
                    The status update will be sent through your email.
                </p>
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={() => Close("Restart")}>
                    Create another
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={() => Close("Entirely")}>
                    Close
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
